<script setup lang="ts">
import { LogoSmallSVG } from '@/shared/images';
import { ProjectSettings } from '@/shared/lib';
import { Loading } from '@/shared/ui';
</script>

<template>
  <div
    class="relative flex min-h-[100dvh] w-full items-center justify-center overflow-hidden px-4 py-6"
  >
    <div class="pointer-events-none absolute inset-0 overflow-hidden">
      <div
        class="absolute top-[-10%] left-[-8%] h-[26rem] w-[26rem] rounded-full bg-[color-mix(in_srgb,var(--button-primary-color),transparent_82%)] opacity-90 blur-[90px]"
      />
      <div
        class="absolute right-[-12%] bottom-[-14%] h-[28rem] w-[28rem] rounded-full bg-[color-mix(in_srgb,var(--button-primary-color),transparent_90%)] opacity-90 blur-[90px]"
      />
    </div>

    <div
      class="relative z-10 flex w-full max-w-sm flex-col items-center gap-7 rounded-[28px] border border-[var(--theme-border-strong)] bg-[var(--theme-surface-raised)] px-8 py-10 shadow-[0_32px_90px_rgba(0,0,0,0.32)] backdrop-blur-[22px]"
    >
      <div class="flex flex-col items-center gap-3">
        <div class="h-14 w-14 drop-shadow-[0_10px_24px_rgba(124,58,237,0.45)]">
          <LogoSmallSVG class="h-full w-full" />
        </div>

        <span
          class="text-[11px] font-semibold tracking-[0.28em] text-[var(--theme-text-primary)] uppercase"
        >
          {{ ProjectSettings.project.name }}
        </span>
      </div>

      <div class="flex flex-col items-center gap-3">
        <Loading
          loading
          type="disappear"
          size="large"
        />
      </div>
    </div>
  </div>
</template>
